/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(window).on("load", function () {
    $(".title-animation-page-load .reveal-text").addClass(
      "reveal-text-active-black"
    );

    setTimeout(function () {
      $(".title-animation-page-load .text-fluffy").addClass("active-text");
    }, 1500);
  });
});

/*
 *
 * ----------------------------------------------- */
$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

/*
 *
 * ----------------------------------------------- */
$(window).on("resize scroll load", function () {
  var $well = $("#well-creative");

  if ($well.length && $well.isInViewport()) {
    setTimeout(function () {
      $("#creative .reveal-text").addClass("reveal-text-active-black");
    }, 2500);
  }
});
